import React, { useEffect, useMemo, useState } from "react";
import "./Table.css";
import CountUp from "react-countup";
import DistrictTable from "./DistrictTable";
import ColumnSearch from "./ColumnSearch";
import { Button, ConfigProvider, Segmented, Tooltip } from 'antd';

function Table({
    data,
    isDistrictView,
    setClientTableExpand,
    modalityCheck,
    districtData,
    mapCode,
    setMapCode,
    setDistrictView,
    setMapStatistic,
    setRegionHighlighted,
    indiaCard,
    clientData
}) {
    // const [tableData,setTableData]=useState([])
    const [sorting, setSorting] = useState({
        column: "potential_clients",
        order: "desc",
    });

    const [search, setSearch] = useState(null)
    const [searchColumn, setSearchColumn] = useState(null)
    console.log(clientData)


    const tableData = useMemo(() => {
        if (sorting?.column == "state") {
            if (sorting?.order == "asc") {
                
                return data?.sort((a, b) => {
                    return a.stateCode?.localeCompare(b.stateCode);
                });

                //console.log(sorting?.column, sorting?.order, "asc");
            } else {
                
                return data?.sort((a, b) => {
                    return b.stateCode.localeCompare(a.stateCode);
                });
            }
            //  setTableData(data1)
        } else {
            if (sorting?.order == "asc") {
                return data?.sort((a, b) => {
                    return a[sorting?.column] - b[sorting?.column];
                });
                //console.log(sorting?.column, sorting?.order, "asc");
                // setTableData(data1)
            } else {
                return data?.sort((a, b) => {
                    return b[sorting?.column] - a[sorting?.column];
                });
                //console.log(sorting?.column, sorting?.order, "desc");
                // setTableData(data1)
            }
        }
    }, [data, sorting?.column, sorting?.order, modalityCheck]);

    

    return (
        <div className="table fadeInUp">
            <div className="table-head">
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (sorting?.column === "state" && sorting?.order === "asc") {
                            setSorting({
                                column: "state",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "state",
                                order: "asc",
                            });
                        }

                        // if(sorting?.column==='state'&&!sorting?.order){
                        //   setSorting({
                        //     column:'state',
                        //     order:'asc'
                        //   })
                        // }else if(!sorting?.column&&!sorting?.order){
                        //     setSorting({
                        //       column:'state',
                        //       order:'asc'
                        //     })
                        // }
                        // else if(sorting?.column!=='state'&&sorting?.order){
                        //     setSorting({
                        //       column:'state',
                        //       order:'asc'
                        //     })
                        //   }
                        //   else if(sorting?.column==='state'&&sorting?.order==='asc'){
                        //     setSorting({
                        //       column:'state',
                        //       order:'desc'
                        //     })
                        //   }else if(sorting?.column==='state'&&sorting?.order==='desc'){
                        //     setSorting({
                        //       column:'state',
                        //       order:'asc'
                        //     })
                        //   }
                    }}
                >
                    <div >State/Ut


                    </div>
                    <div style={{ display: 'flex' }}>
                        {sorting?.column === "state" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}

                        <ColumnSearch className={'disrict-seacrh'} setSearch={setSearch} setSearchColumn={setSearchColumn} column={'state'} />
                    </div>
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (
                            sorting?.column === "potential_clients" &&
                            sorting?.order === "asc"
                        ) {
                            setSorting({
                                column: "potential_clients",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "potential_clients",
                                order: "asc",
                            });
                        }
                    }}
                >
                    <div>Propsect</div>
                    <div>
                        {sorting?.column === "potential_clients" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (
                            sorting?.column === "onboarded_clients" &&
                            sorting?.order === "asc"
                        ) {
                            setSorting({
                                column: "onboarded_clients",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "onboarded_clients",
                                order: "asc",
                            });
                        }
                    }}
                >
                    <div>Onboard</div>
                    <div>
                        {sorting?.column === "onboarded_clients" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (sorting?.column === "ACTIVE" && sorting?.order === "asc") {
                            setSorting({
                                column: "ACTIVE",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "ACTIVE",
                                order: "asc",
                            });
                        }
                    }}
                >
                    <div>Active</div>
                    <div>
                        {sorting?.column === "ACTIVE" && (
                            <>
                                {sorting?.order === "asc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        if (sorting?.column === "INACTIVE" && sorting?.order === "asc") {
                            setSorting({
                                column: "INACTIVE",
                                order: "desc",
                            });
                        } else {
                            setSorting({
                                column: "INACTIVE",
                                order: "asc",
                            });
                        }
                    }}
                >
                    <div>InActive</div>
                    <div>
                        {sorting?.column === "INACTIVE" && (
                            <>
                                {sorting?.order === "desc" ? (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-asc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="m12.927 2.573 3 3A.25.25 0 0 1 15.75 6H13.5v6.75a.75.75 0 0 1-1.5 0V6H9.75a.25.25 0 0 1-.177-.427l3-3a.25.25 0 0 1 .354 0ZM0 12.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Zm0-4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0-4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Z"></path>
                                    </svg>
                                ) : (
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        role="img"
                                        class="octicon octicon-sort-desc"
                                        viewBox="0 0 16 16"
                                        width="12"
                                        height="12"
                                        fill="currentColor"
                                    >
                                        <path d="M0 4.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 4.25Zm0 4a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8.25Zm0 4a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75ZM13.5 10h2.25a.25.25 0 0 1 .177.427l-3 3a.25.25 0 0 1-.354 0l-3-3A.25.25 0 0 1 9.75 10H12V3.75a.75.75 0 0 1 1.5 0V10Z"></path>
                                    </svg>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div
                className="table-head india-head"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    setDistrictView(false);
                    setMapCode("TT");
                }}

            >
                <div onClick={() => {
                    setClientTableExpand({
                        state: "TT",
                        district: null,
                        stage: 'prospects'
                    })
                }}>India</div>
                <div
                    className="prospect"
                    onMouseEnter={() => {
                        setMapStatistic("clients");
                        setRegionHighlighted({
                            stateCode: "TT",
                            value: indiaCard?.client,
                        });
                    }}


                    onClick={() => {
                        setClientTableExpand({
                            state: "TT",
                            district: null,
                            stage: 'prospects'
                        })
                    }}
                >
                    
                    <CountUp
                                    start={0}
                                    end={indiaCard?.client}
                                    duration={0.5}
                                    delay={0}
                                />
                </div>
                <Tooltip style={{height:'200px',overflowY:'scroll'}} placement="left" title={clientData?.filter(data=>{
                    if(data['master.status']==='ACTIVE' ||data['master.status']==='INACTIVE'){
                        return data
                    }
                })
                    ?.map((data)=>( <div>
                     {data?.['master.client_name']}
                </div>))} >
                <div
                    onMouseEnter={() => {
                        setMapStatistic("onboard");
                        setRegionHighlighted({
                            stateCode: "TT",
                            value: indiaCard?.onboard,
                        });
                    }}

                    onClick={() => {
                        setClientTableExpand({
                            state: "TT",
                            district: null,
                            stage: 'onboard'
                        })
                    }}
                >
                     <CountUp
                                    start={0}
                                    end={indiaCard?.onboard}
                                    duration={0.5}
                                    delay={0}
                                />
                 
                </div>
                </Tooltip>
                <div
                    onMouseEnter={() => {
                        setMapStatistic("active");
                        setRegionHighlighted({
                            stateCode: "TT",
                            value: indiaCard?.active,
                        });
                    }}

                    onClick={() => {
                        setClientTableExpand({
                            state: "TT",
                            district: null,
                            stage: 'active'
                        })
                    }}
                >
                    <CountUp
                                    start={0}
                                    end={indiaCard?.active}
                                    duration={0.5}
                                    delay={0}
                                />
                </div>
                <div
                    onMouseEnter={() => {
                        setMapStatistic("inactive");
                        setRegionHighlighted({
                            stateCode: "TT",
                            value: indiaCard?.inactive,
                        });
                    }}

                    onClick={() => {
                        setClientTableExpand({
                            state: "TT",
                            district: null,
                            stage: 'inactive'
                        })
                    }}
                >
                    {" "}
                    <CountUp
                                    start={0}
                                    end={indiaCard?.inactive}
                                    duration={0.5}
                                    delay={0}
                                />
                    
                </div>
            </div>

            <div className="table-body fadeInUp">
                {[...tableData]?.filter(data => {
                    if (search === null || search === '') {
                        return data
                    } else {
                        if (data[searchColumn]?.toString()?.toLowerCase()?.includes(search?.toString()?.toLowerCase())) {
                            return data
                        }
                    }
                })?.map((data, id) => (
                    <div key={id}>
                        <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                if (data?.stateCode == "TT") {
                                    setDistrictView(false);
                                } else {
                                    setDistrictView(true);
                                }
                                setMapCode(data?.stateCode);
                                // //console.log(isDistrictView)
                            }}
                        >
                            <div className="fadeInUp">{data["state"]}</div>
                            <div
                                className="fadeInUp"
                                onMouseEnter={() => {
                                    setMapStatistic("clients");
                                    setRegionHighlighted({
                                        stateCode: data?.stateCode,
                                        value: data?.potential_clients,
                                    });
                                }}

                                onClick={() => {
                                    setClientTableExpand({
                                        state: data?.stateCode,
                                        district: null,
                                        stage: 'prospects'
                                    })
                                }}
                            >
                                <CountUp
                                    start={0}
                                    end={data?.potential_clients}
                                    duration={0.5}
                                    delay={0}
                                />
                            </div>
                            <Tooltip style={{height:'200px',overflowY:'scroll'}} placement="left" title={clientData?.filter(data1=>{
                    if((data1['master.status']==='ACTIVE' ||data1['master.status']==='INACTIVE') && data1['stateCode']===data?.stateCode){
                        return data
                    }
                })
                    ?.map((data)=>( <div>
                     {data?.['master.client_name']}
                </div>))} >
                            <div
                                className="fadeInUp"
                                onMouseEnter={() => {
                                    setMapStatistic("onboard");
                                    setRegionHighlighted({
                                        stateCode: data?.stateCode,
                                        value: data?.onboarded_clients,
                                    });
                                }}
                                onClick={() => {
                                    setClientTableExpand({
                                        state: data?.stateCode,
                                        district: null,
                                        stage: 'onboard'
                                    })
                                }}
                            >
                                <CountUp
                                    start={0}
                                    end={data?.onboarded_clients}
                                    duration={0.5}
                                    delay={0}
                                />
                            </div>

                            </Tooltip>
                            <div
                                className="fadeInUp"
                                onMouseEnter={() => {
                                    setMapStatistic("active");
                                    setRegionHighlighted({
                                        stateCode: data?.stateCode,
                                        value: data?.ACTIVE,
                                    });
                                }}

                                onClick={() => {
                                    setClientTableExpand({
                                        state: data?.stateCode,
                                        district: null,
                                        stage: 'active'
                                    })
                                }}
                            >
                                <CountUp
                                    start={0}
                                    end={data?.ACTIVE}
                                    duration={0.5}
                                    delay={0}
                                />
                            </div>
                            <div
                                className="fadeInUp"
                                onMouseEnter={() => {
                                    setMapStatistic("inactive");
                                    setRegionHighlighted({
                                        stateCode: data?.stateCode,
                                        value: data?.INACTIVE,
                                    });
                                }}

                                onClick={() => {
                                    setClientTableExpand({
                                        state: data?.stateCode,
                                        district: null,
                                        stage: 'inactive'
                                    })
                                }}
                            >
                                <CountUp
                                    start={0}
                                    end={data?.INACTIVE}
                                    duration={0.5}
                                    delay={0}
                                />
                            </div>
                        </div>

                        {isDistrictView && data?.stateCode === mapCode && (
                            <DistrictTable
                            clientData={clientData}
                                setClientTableExpand={setClientTableExpand}
                                setRegionHighlighted={setRegionHighlighted}
                                data={districtData?.filter(
                                    (data) => data?.stateCode === mapCode
                                )}
                                setMapStatistic={setMapStatistic}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Table;
